<!--section about us-->
<div class="section termsrow">
    <div class="container-fluid">
        <div class="row" style="height:360px">
            <div class="col-md-12 text-center">
                <div class="white_fonts">
                    <div class="row animate__animated animate__fadeInUp top">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <header class="section-header">
                                <h3>Terms of Service</h3>
                            </header>                           
                        </div>
                        <div class="col-sm-2"></div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
<!-- end section -->

<!-- row 1 -->
<div class="section layout_padding">
    <div class="container">
        <div class="row">
            <div class="col-lg-12 text-center">
                <h2 class="theme_color">
                    <span class="centerFontSize">TERMS OF SERVICE</span><br/>
                    <span class="mediumFontSize">Last Modified May 1, 2026</span>
                </h2>               
            </div>
        </div>
    </div>
</div>
<!-- end section-->

<!-- row 1 <i class="fa fa-circle fontRed facirclesize"></i>-->
<div class="section">
    <div class="container">
        <div class="row">            
             <div class="col-lg-12" *ngFor="let term of termDetails" > <!-- data-aos="fade-up" data-aos-delay="100" -->
                <h1 class="theme_color"><strong>{{term.headingnumber}}.</strong>&nbsp; {{term.heading}} <label class="subheading" [innerHtml]="term.subheading" ></label> </h1>

                <ul class="theme_color fontSize"  *ngFor="let det of term.details" style="padding: 15px;">
                    <li><span [innerHtml]="det"></span></li>
                </ul>

                <hr *ngIf="termDetails.length!==term.id" color="#d8d9d9"/>
            </div>
        </div>
    </div>
</div>
<!-- end section-->
